var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDerslikler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 153,
    viewBox: "0 0 200 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41975 128.422C4.87698 128.26 3.253 128.747 2.11622 129.883C0.0862587 131.913 0.0862587 135.16 2.11622 137.189C3.253 138.326 4.87698 138.813 6.41975 138.651C7.96252 138.813 9.5865 138.326 10.7233 137.189C12.7532 135.16 12.7532 131.913 10.7233 129.883C9.5053 128.747 7.96252 128.26 6.41975 128.422Z",
    fill: "#F99E1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5802 68.8838C18.2767 68.8838 14.7852 72.3745 14.7852 76.6769C14.7852 80.9794 18.2767 84.4701 22.5802 84.4701C26.8837 84.4701 30.3753 80.9794 30.3753 76.6769C30.359 72.3745 26.8675 68.8838 22.5802 68.8838Z",
    fill: "#F99E1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.727 118.013C183.043 118.013 178.35 122.64 178.35 128.387C178.35 134.151 182.978 138.762 188.727 138.762C194.411 138.762 199.104 134.135 199.104 128.387C199.12 122.64 194.492 118.013 188.727 118.013Z",
    fill: "#F99E1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.05 63.707C167.925 63.707 170.247 66.0287 170.247 68.9025C170.247 71.7762 167.925 74.0979 165.05 74.0979C162.176 74.0979 159.854 71.7762 159.854 68.9025C159.854 66.0287 162.192 63.707 165.05 63.707Z",
    fill: "#F99E1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.31 19.3662C142.184 19.3662 144.507 21.6879 144.507 24.5616C144.507 27.4354 142.184 29.7571 139.31 29.7571C136.436 29.7571 134.113 27.4354 134.113 24.5616C134.13 21.7042 136.452 19.3662 139.31 19.3662Z",
    fill: "#F99E1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2787 24.9346C24.1532 24.9346 26.4755 27.2563 26.4755 30.13C26.4755 33.0037 24.1532 35.3254 21.2787 35.3254C18.4043 35.3254 16.082 33.0037 16.082 30.13C16.082 27.2563 18.4043 24.9346 21.2787 24.9346Z",
    fill: "#F99E1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.341 0.0292969C161.216 0.0292969 163.538 2.351 163.538 5.22472C163.538 8.09844 161.216 10.4201 158.341 10.4201C155.467 10.4201 153.145 8.09844 153.145 5.22472C153.161 2.351 155.483 0.0292969 158.341 0.0292969Z",
    fill: "#F99E1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182 17.268V33.1593H142.272L114.7 72.8874H134.326V88.7787H122.09L151.568 152.344H134.088L126.698 136.453H57.8892L49.7052 152.344H31.8275L64.643 88.7787H62.8155C59.2399 88.7787 56.2206 86.395 55.1877 83.2168L30 8.05105L37.5484 5.34954C41.6801 4.07824 46.2091 6.38247 47.5599 10.5142L68.5363 72.8874H103.338L130.91 33.1593H102.544V17.268H182ZM82.6796 88.7787L66.1526 120.561H119.309L104.61 88.7787H82.6796Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerslikler);
export default __webpack_public_path__ + "static/media/derslikler.edc366fe4e773615bd7d8daeebae2e55.svg";
export { ForwardRef as ReactComponent };